import React from "react";

// The report dashboard (Sales, Daily Performance, Visitors & Drop-off,
// Trends, Item Favorites, Growth Cohort) is a large, self-contained HTML
// page — its own <style>, Chart.js from a CDN, and vanilla-JS tab logic —
// already wired directly to the live backend (DD_API_BASE inside the file).
// It's embedded here via iframe rather than rewritten as React components:
// that keeps the exact, already-tested implementation intact instead of a
// separate line-for-line port that could silently drift from it.
//
// Source file lives at DD_Test_Frontend/public/reports-dashboard.html —
// Create React App serves anything in public/ at the site root, so it's
// reachable directly at /reports-dashboard.html too.
const ReportsDashboard = () => {
  return (
    <iframe
      title="DailyDish Reports"
      src="/reports-dashboard.html"
      style={{
        width: "100%",
        height: "calc(100vh - 80px)",
        border: "none",
        display: "block",
      }}
    />
  );
};

export default ReportsDashboard;
